<template>
  <v-app>
    <v-main class="bg-surface">
      <v-container class="fill-height" fluid>
        <v-row
          align="center"
          justify="center"
          class="ma-0"
        >
          <v-col cols="12" sm="8" md="4">
            <v-img
              src="/icon-512.png"
              alt="Logo"
              width="250"
              class="rounded-circle mx-auto d-block mb-10"
            />
            
            <v-text-field
              class="blue-textfield"
              color="blue"
              base-color="blue"
              v-model="email"
              label="Email"
              type="email"
              autocomplete="email"
              :prepend-icon="mdiAccount"
              density="comfortable"
              variant="outlined"
              required
            >
            </v-text-field>

              <v-text-field
              class="blue-textfield"
                color="blue"
                base-color="blue"
                v-model="password"
                label="Mot de passe"
                type="password"
                autocomplete="current-password"
                :prepend-icon="mdiLock"
                variant="outlined"
                density="comfortable"
                required
              />
              <v-btn variant="outlined" class="blue-button" color="blue" @click="login" block>
                <v-icon :icon="mdiLogin" />Se connecter
              </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import { supabase } from '../supabase/client';
import { useRouter } from 'vue-router';
import { mdiLogin, mdiConnection, mdiAccount, mdiLock } from '@mdi/js'

const email = ref('');
const password = ref('');
const router = useRouter();

const login = async () => 
{
  console.log('-- Debut fonction de loggin --');

  console.log('Debut authentification supabase');
  const { data, error } = await supabase.auth.signInWithPassword({
    email: email.value,
    password: password.value,
  });
  console.log('Fin authentification supabase');
  if (error) {
    console.error('Erreur de connexion supabase: ' + error.message);
    alert('Erreur de connexion : ' + error.message);
    return;
  }else{
      console.log('Connexion réussie pour', data.user?.email);
      console.log('Connexion réussie pour', data.user?.id);
      console.log('redirection vers home');
      console.log('-- Fin fonction de loggin --');
      router.push('/app');
  }
};
</script>
  
